import './ListToFitFieldLayout.scss';

/**
 * A component that lays out its children - expected to be Field components or similar -
 * in a list such that they will fit the space provided
 *
 * Note this is a "layout" not a "section" - it only organises fields and does not support worksheet section features (e.g. messages).
 */
const ListToFitFieldLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="ListToFitFieldLayout">{children}</div>;
};

export { ListToFitFieldLayout };
export default ListToFitFieldLayout;
